import React from "react";
import "./Keys.css";

const Keys = () => {
  return (
    <div className="keys">
      <div className="wrapper">
        <div className="keys-intro-heading">
          <h2>
            Co warto wiedzieć o "Weselu", czyli cztery zagadnienia, które
            maturzysta powinien znać:
          </h2>
        </div>
      </div>
      <div className="keys-specialization">
        <h3></h3>
        <p>
          Wesele Stanisława Wyspiańskiego uznane za&nbsp;
          <mark>arcydramat narodowy</mark> jest przede wszystkim ostrą&nbsp;
          <mark>krytyką polskiego społeczeństwa końca XIX wieku</mark>. Autor
          demaskuje w&nbsp;nim mit tak modnej w&nbsp;czasach modernizmu &nbsp;
          <mark>chłopomanii</mark>, ukazując, że inteligenci i&nbsp;chłopi żyją
          w dwóch odrębnych światach a bratnie się gości z&nbsp;miasta
          z&nbsp;ludem jest jedynie czystym pozorem. W&nbsp;istocie dekadencka
          inteligencja szuka na wsi jedynie spokoju, ucieka od zgiełku historii
          i&nbsp;polityki w&nbsp;świat bajecznie kolorowych strojów. Zauroczona
          odświętnym wizerunkiem chłopa nie wie nic na temat prawdziwych realiów
          życia wiejskiego, traktuje chłopów z&nbsp;lekceważeniem, nie
          dostrzegając w&nbsp;nich godnego partnera do wspólnego działania.
          Chłopi tymczasem są bardziej oświeceni, garną się do walki, mają zapał
          i&nbsp;entuzjazm, ale potrzebują przywódcy. Gdy przychodzi moment
          podjęcia walki, żadna z&nbsp;warstw nie jest w&nbsp;stanie sprostać
          wyzwaniu.
        </p>
        <br />
        <p>
          <b>Poeta</b> owładnięty dekadencją, chociaż marzy o&nbsp;przywództwie,
          boi się czynu.
        </p>
        <p>
          <b>Dziennikarz</b> rozpamiętuje dawne klęski zamiast namawiać do
          walki.
        </p>
        <p>
          <b>Gospodarz</b> okazuje się nieodpowiedzialny, oddaje powierzony
          przez <b>Wernyhorę złoty róg Jaśkowi</b>, lekceważąc tym samym misję,
          do jakiej został powołany. <b>Jasiek</b> nad sprawę narodową
          przedkłada własne interesy. Gubi <b>złoty róg</b>, schylając się po
          <b>czapkę z piór</b> – &nbsp;
          <mark>symbol próżności i&nbsp;marzeń o&nbsp;bogactwie</mark>.
        </p>
        <p>
          Nikt nie jest w&nbsp;stanie udźwignąć ciężaru zadania. Społeczeństwo
          popada w&nbsp;letarg,{" "}
          <mark>
            tańczy hipnotyczny taniec w&nbsp;rytm muzyki chochoła uosabiającego
            jarzmo niewoli
          </mark>
          . Finał dramatu obnaża polską niemoc, brak nadziei, bierność, poddanie
          się zniewoleniu. Społeczeństwo polskie zaprzepaściło szansę na
          niepodległość, bo zwyciężyły go dawne urazy, wzajemna niechęć
          a&nbsp;przede wszystkim brak woli konstruktywnego działania.
        </p>
        <br />
        <p>
          "Wesele" – chociaż&nbsp;
          <mark>obnaża bezradność i&nbsp;marazm polskiego społeczeństwa</mark> –
          nie jest utworem aż tak dalece pesymistycznym. Przynosi również pewną
          nadzieję zawartą w&nbsp;wieloznacznej symbolice chochoła.
          <b> Chochoł</b> – snop słomy okrywający kwiat róży – to nie
          tylko&nbsp;
          <mark>
            znak niewoli narodowej, ale również zapowiedź przyszłego zwycięstwa
          </mark>
          . Słomę zdejmuje się na wiosnę i&nbsp;wtedy róża budzi się ze snu,
          rozkwita najpiękniejszym z&nbsp;kwiatów – Polska również obudzi się
          z&nbsp;letargu i&nbsp;odżyje, musi tylko przyjść na to odpowiedni
          moment.&nbsp;
          <mark>
            Zwiastunem przyszłego zwycięstwa jest również <b>złota podkowa </b>
            zgubiona przez konia <b>Wernyhory</b>
          </mark>
          . <b>Gospodyni</b> zapobiegliwie chowa ją do kufra. Może to przejaw
          zwykłej chłopskiej pazerności, może jednak&nbsp;
          <mark>
            symbol powodzenia sprawy narodowej odłożonej na razie w&nbsp;czasie,
            który przyjdzie w&nbsp;odpowiedniej chwili
          </mark>
          .
        </p>
        <br />
        <p>
          Utwór Wyspiańskiego operuje wizją, symbolem, przywołuje na scenę
          postaci – zjawy takie jak
          <b> Widmo, Stańczyk, Rycerz, Hetman, Upiór i&nbsp;Wernyhora</b>. Są
          one&nbsp;
          <mark>
            symbolicznym uosobieniem konfliktów i&nbsp;pragnień gości weselnych
          </mark>
          , którym się pojawiają. Poszerzają charakterystykę postaci, rzucają
          szersze światło na wzajemne relacje inteligencko-chłopskie:
        </p>
        <br />
        <p>
          <mark>
            <b>Widmo</b> to projekcja tęsknoty miłosnej Marysi
          </mark>
          , której narzeczony malarz de Laveaux zmarł na gruźlicę.
        </p>
        <p>
          <b>Stańczyk</b> – błazen Zygmunta Starego jest&nbsp;
          <mark>
            wyrzutem sumienia <b>Dziennikarza</b>
          </mark>
          , zwolennika lojalizmu wobec zaborcy. Przypomina mu o&nbsp;dawnej
          świetności Polski Jagiellonów, każe działać a nie rozmyślać o
          klęskach.
        </p>
        <p>
          <b>Rycerz</b> czyli Zawisza Czarny –&nbsp;
          <mark>
            symbol siły i&nbsp;czynu wyraża rozterki <b>Poety</b> – dekadenta
          </mark>
          , który widzi się w&nbsp;kostiumie romantycznego wieszcza porywającego
          tłumy do walki, ale boi się czynu i&nbsp;odpowiedzialności.
        </p>
        <p>
          <b>Hetman</b> – Branicki, niechlubny bohater Targowicy, zdrajca
          i&nbsp;sprzedawczyk, ukazując się <b>Panu Młodemu</b>,&nbsp;
          <mark>
            symbolizuje jego poczucie zdrady własnej warstwy poprzez małżeństwo
            z&nbsp;chłopką
          </mark>
          .
        </p>
        <p>
          <b>Upiór</b> Jakuba Szeli przypomina Dziadowi&nbsp;
          <mark>
            o&nbsp;rzezi polskiej szlachty w&nbsp;czasie powstania chłopskiego
            w&nbsp;1846 roku
          </mark>
          .
        </p>
        <br />
        <p>
          Dramat Wyspiańskiego stanowi przykład&nbsp;
          <mark>
            utworu scenicznego ukształtowanego według nowoczesnych kanonów
            sztuki modernistycznej
          </mark>
          :
        </p>
        <p>
          Realizuje młodopolską zasadę&nbsp;
          <mark>
            „syntezy sztuk”, która słowo literackie łączy z&nbsp;elementami
            malarsko-muzyczno-tanecznymi, tworząc złożoną, wielowarstwową
            kompozycję
          </mark>
          .
        </p>
        <p>
          Posługuje się wieloma kategoriami estetycznymi:&nbsp;
          <mark>
            patos miesza z&nbsp;groteską, komizm z&nbsp;tragizmem, liryzm
            z&nbsp;satyrą
          </mark>
          . Rozpoczyna się w&nbsp;konwencji szopki politycznej, kończy atmosferą
          podniosłego misterium.
        </p>
        <p>Zestawia plan realistyczny z&nbsp;symbolem i&nbsp;wizją.</p>
        <p>
          <br />
          <em>
            aleklasa.pl/matura/c266-lektury-klucze-maturalne/wesele-matura
          </em>
        </p>
      </div>
    </div>
  );
};

export default Keys;
